module.exports = __webpack_public_path__ + "static/img_05-8977df59fb0e5c2919ba655973f72839.png";